<template>
  <v-toolbar v-if="editor" flat class="mx-auto my-auto" extended>
    <v-row class="px-2 mb-2" justify="space-between">
      <v-btn-toggle class="ma-2">
        <v-btn
          small
          :color="
            editor.isActive('heading', { level: 1 }) ? 'grey lighten-1' : ''
          "
          @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
        >
          <v-icon>mdi-format-header-1</v-icon>
        </v-btn>
        <v-btn
          small
          :color="
            editor.isActive('heading', { level: 2 }) ? 'grey lighten-1' : ''
          "
          @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
        >
          <v-icon>mdi-format-header-2</v-icon>
        </v-btn>
        <v-btn
          small
          :color="
            editor.isActive('heading', { level: 3 }) ? 'grey lighten-1' : ''
          "
          @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
        >
          <v-icon>mdi-format-header-3</v-icon>
        </v-btn>
        <v-btn
          small
          :color="editor.isActive('paragraph') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().setParagraph().run()"
          class="p5"
        >
          <v-icon>mdi-format-paragraph</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-btn-toggle class="pa-2">
        <v-btn
          small
          :color="editor.isActive('bold') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().toggleBold().run()"
        >
          <v-icon>mdi-format-bold</v-icon>
        </v-btn>
        <v-btn
          small
          :color="editor.isActive('italic') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().toggleItalic().run()"
        >
          <v-icon>mdi-format-italic</v-icon>
        </v-btn>
        <v-btn
          small
          :color="editor.isActive('underline') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().toggleUnderline().run()"
        >
          <v-icon>mdi-format-underline</v-icon>
        </v-btn>
        <v-btn
          small
          :color="editor.isActive('strike') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().toggleStrike().run()"
        >
          <v-icon>mdi-format-strikethrough</v-icon>
        </v-btn>
        <v-btn
          small
          :color="editor.isActive('highlight') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().toggleHighlight().run()"
        >
          <v-icon>mdi-format-color-highlight</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle class="pa-2">
        <v-btn
          small
          :color="editor.isActive('bulletList') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().toggleBulletList().run()"
        >
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>
        <v-btn
          small
          :color="editor.isActive('orderedList') ? 'grey lighten-1' : ''"
          @click="editor.chain().focus().toggleOrderedList().run()"
        >
          <v-icon>mdi-format-list-numbered</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-btn-toggle class="pa-2">
        <v-btn
          small
          :color="
            editor.isActive({ textAlign: 'left' }) ? 'grey lighten-1' : ''
          "
          @click="editor.chain().focus().setTextAlign('left').run()"
        >
          <v-icon>mdi-format-align-left</v-icon>
        </v-btn>
        <v-btn
          small
          :color="
            editor.isActive({ textAlign: 'center' }) ? 'grey lighten-1' : ''
          "
          @click="editor.chain().focus().setTextAlign('center').run()"
        >
          <v-icon>mdi-format-align-center</v-icon>
        </v-btn>
        <v-btn
          small
          :color="
            editor.isActive({ textAlign: 'right' }) ? 'grey lighten-1' : ''
          "
          @click="editor.chain().focus().setTextAlign('right').run()"
        >
          <v-icon>mdi-format-align-right</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-btn-toggle class="pa-2">
        <v-btn
          small
          @click="
            editor
              .chain()
              .focus()
              .insertTable({ rows: 3, cols: 3, withHeaderRow: true })
              .run()
          "
        >
          <v-icon>mdi-table-plus</v-icon>
        </v-btn>
        <v-btn
          small
          @click="editor.chain().focus().deleteTable().run()"
          :disabled="!editor.can().deleteTable()"
        >
          <v-icon>mdi-table-remove</v-icon>
        </v-btn></v-btn-toggle
      ><v-btn-toggle class="pa-2">
        <v-btn
          small
          @click="editor.chain().focus().addColumnBefore().run()"
          :disabled="!editor.can().addColumnBefore()"
        >
          <v-icon>mdi-table-row-plus-before</v-icon>
        </v-btn>
        <v-btn
          small
          @click="editor.chain().focus().addColumnAfter().run()"
          :disabled="!editor.can().addColumnAfter()"
        >
          <v-icon>mdi-table-column-plus-after</v-icon>
        </v-btn>
        <v-btn
          small
          @click="editor.chain().focus().deleteColumn().run()"
          :disabled="!editor.can().deleteColumn()"
        >
          <v-icon>mdi-table-column-remove</v-icon>
        </v-btn>
        <v-btn
          small
          @click="editor.chain().focus().addRowBefore().run()"
          :disabled="!editor.can().addRowBefore()"
        >
          <v-icon>mdi-table-row-plus-before</v-icon>
        </v-btn>
        <v-btn
          small
          @click="editor.chain().focus().addRowAfter().run()"
          :disabled="!editor.can().addRowAfter()"
        >
          <v-icon>mdi-table-row-plus-after</v-icon>
        </v-btn>
        <v-btn
          small
          @click="editor.chain().focus().deleteRow().run()"
          :disabled="!editor.can().deleteRow()"
        >
          <v-icon>mdi-table-row-remove</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-btn-toggle class="pa-2"
        ><v-btn
          small
          @click="editor.chain().focus().mergeCells().run()"
          :disabled="!editor.can().mergeCells()"
        >
          <v-icon>mdi-table-merge-cells</v-icon>
        </v-btn>
        <v-btn
          small
          @click="editor.chain().focus().splitCell().run()"
          :disabled="!editor.can().splitCell()"
        >
          <v-icon>mdi-table-split-cell</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle class="pa-2">
        <v-btn
          small
          @click="editor.chain().focus().toggleHeaderCell().run()"
          :disabled="!editor.can().toggleHeaderCell()"
        >
          <v-icon>mdi-alpha-h-box</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-btn-toggle class="pa-2">
        <v-btn small @click="imageDialog = true">
          <v-icon> mdi-image </v-icon>
        </v-btn>

        <v-btn small @click="jsonDialog = true">
          <v-icon> mdi-code-json </v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-row>

    <v-dialog v-model="imageDialog" max-width="800">
      <v-card>
        <v-card-title>Add image</v-card-title>
        <v-card-text>
          <v-file-input
            accept="image/*"
            label="Image input"
            chips
            ref="image"
            prepend-icon="mdi-image"
            :rules="imageRules"
            v-model="image"
            @change="uploadAndSetImage"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="jsonDialog" max-width="800">
      <v-card>
        <v-card-title>Add dataJSON</v-card-title>
        <v-card-text>
          <v-file-input
            accept="json/*"
            label="dataJSON input"
            chips
            ref="json"
            prepend-icon="mdi-code-json"
            :rules="imageRules"
            v-model="json"
            @change="uploadAndSetJSON"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import store from "@/store";
import axios from "axios";
export default {
  data() {
    return {
      valid: true,
      json: null,
      jsonDialog: false,
      image: null,
      imageDialog: false,
      imageRules: [
        (value) =>
          !value ||
          value.size < 10000000 ||
          "Image size should be less than 10 MB!",
      ],
    };
  },
  props: ["editor"],
  methods: {
    async uploadAndSetImage() {
      if (!this.$refs.image.validate()) return;

      if (this.image) {
        let url = await store.dispatch("uploadImage", { image: this.image });
        this.editor.chain().focus().setImage({ src: url }).run();
        this.imageDialog = false;
        this.image = null;
      }
    },
    async uploadAndSetJSON() {
      if (!this.$refs.json.validate()) return;

      if (this.json) {
        let url = await store.dispatch("uploadJSON", { json: this.json });
        let { data } = await axios.get(url);
        this.editor
          .chain()
          .focus()
          .setContent(`<pre>${JSON.stringify(data, null, 2)}</pre>`)
          .run();
        this.jsonDialog = false;
        this.json = null;
      }
    },
  },
};
</script>
